// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__1ctQF","label":"Category_label__Pyx36","content":"Category_content__zZ5oc","header":"Category_header__V2v5z","location":"Category_location__eWNxY"};